module.exports = __webpack_public_path__ + "img/zhxy_image_4.c3d1cf59.png";